import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarTodosEstados(api) {       
    let parametros = {
      operacao: 'buscarTodosEstados'
    };

    let retorno = {};

    await api.santriGET('/rest/estado', parametros, 10, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/REstado.js